import { render, staticRenderFns } from "./MyOrder.vue?vue&type=template&id=0e56b5b2&scoped=true"
import script from "./MyOrder.vue?vue&type=script&lang=js"
export * from "./MyOrder.vue?vue&type=script&lang=js"
import style0 from "./MyOrder.vue?vue&type=style&index=0&id=0e56b5b2&prod&lang=less&scoped=true"
import style1 from "./MyOrder.vue?vue&type=style&index=1&id=0e56b5b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56b5b2",
  null
  
)

export default component.exports